export const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const PASSWORD_REGEX = /^.{8,}$/;
export const SSN_REGEX = /^[0-9]{3}-?[0-9]{2}-?[0-9]{4}$/;
export const DATE_REGEX =
  /((0[1-9]|1[0-2])\/?((0|1)[0-9]|2[0-9]|3[0-1])\/?((19|20)\d\d))$/;
export const PHONE_REGEX =
  /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/;
export const CURRENCY_SYMBOL_REGEX =
  /[,\xA2-\xA5\u058F\u060B\u09F2\u09F3\u09FB\u0AF1\u0BF9\u0E3F\u17DB\u20A0-\u20BD\uA838\uFDFC\uFE69\uFF04\uFFE0\uFFE1\uFFE5\uFFE6]/;

export const API_URL_BASE =
  'https://us-central1-mnc-cloud-ae72a.cloudfunctions.net';
export const DEFAULT_ENV = 'development';
export const envsWithLoggingEnable = ['development', 'dev', 'feature', 'qa'];

export const validFileTypes = [
  { mimeType: 'text/csv', kind: 'Comma-separated values (CSV)', extension: '.csv' },
  { mimeType: 'application/msword', kind: 'Microsoft Word', extension: '.doc' },
  // { mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', kind: 'Microsoft Word (OpenXML)', extension: '.docx' },
  { mimeType: 'application/pdf', kind: 'Adobe Portable Document Format (PDF)', extension: '.pdf' },
  // { mimeType: 'application/vnd.ms-powerpoint', kind: 'Microsoft PowerPoint', extension: '.ppt' },
  // { mimeType: 'application/vnd.openxmlformats-officedocument.presentationml.presentation', kind: 'Microsoft PowerPoint (OpenXML)', extension: '.pptx' },
  // { mimeType: 'application/vnd.ms-excel', kind: 'Microsoft Excel', extension: '.xls' },
  // { mimeType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', kind: 'Microsoft Excel (OpenXML)', extension: '.xlsx' },
  // { mimeType: 'application/vnd.ms-excel.sheet.macroenabled.12', kind: 'Office Excel 2007 macro-enabled workbook', extension: '.xlsm' },
  { mimeType: 'image/jpeg', kind: 'JPEG Image', extension: '.jpg' },
  {
    mimeType: 'image/png',
    kind: 'Portable Network Graphics',
    extension: '.png',
  },
];
